import { defineAsyncComponent } from 'vue';
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const ShareIcons = defineAsyncComponent(() => import('@/js/components/Tippy/ShareTippy/ShareIcons.vue'));
const ShareTippy = defineAsyncComponent(() => import('@/js/components/Tippy/ShareTippy/ShareTippy.vue'));
const LearnListButton = defineAsyncComponent(() => import('@/js/global/buttons/LearnListButton.vue'));
const SocialsChart = defineAsyncComponent(() => import('@/js/other/SocialsChart.vue'));
const LatestNewsAndVideos = defineAsyncComponent(() => import('@/js/global/widgets/LatestNewsAndVideos.vue'));

app.use(VueSplide);

app.component('ShareIcons', ShareIcons);
app.component('LearnListButton', LearnListButton);
app.component('ShareTippy', ShareTippy);
app.component('SocialsChart', SocialsChart);
app.component('LatestNewsAndVideos', LatestNewsAndVideos);

mountApp();
